import { FC } from "react";
import { EmptyStates } from "components";
import { Link } from "react-router-dom";
import { useStateSpecies } from "hooks";

export const EmptyStatesMyCattleTab: FC = () => {
  const { activeSpecies } = useStateSpecies();

  if (!activeSpecies) {
    return null;
  }

  return (
    <EmptyStates
      animation={"searching"}
      title={`You haven't added any ${activeSpecies?.slug}.`}
      // buttonCaption="Import animals"
    >
      <p>
        Add livestock by importing a csv file via our <Link to="/system/import">import page</Link>. <br />
        Alternatively, you can upload and manage them on your{" "}
        <a
          href="https://help.breedr.co/en/articles/6538101-new-add-animal-scan-passport-cattle"
          target="_blank"
          rel="noopener noreferrer"
        >
          mobile device
        </a>
        .
      </p>
    </EmptyStates>
  );
};
